<template>
    <div>
        <!-- default-expand-all -->
        <el-input
          v-if="popover === false"
          placeholder="输入关键字进行过滤"
          v-model="filterText">
        </el-input>
        <el-tree
            ref="tree"
            v-if="popover === false"
            highlight-current
            node-key="id"
            :current-node-key="selectNodeId"
            :default-expanded-keys="idExpandedArr"
            :expand-on-click-node="false"
            :data="treeData"
            :props="defaultProps"
            :filter-node-method="filterNode"
            @node-click="handleTreeNode"
            :class="defaultClass"
        />

        <el-popover
            v-if="popover === true"
            placement="bottom"
            width="320"
            trigger="click"
            v-model="visible" 
            @after-enter='treeShow'>
            <el-input
              v-if="!isRead"
              placeholder="输入关键字进行过滤"
              v-model="filterText"> 
            </el-input>
            <el-tree
                v-if="!isRead"
                highlight-current
                ref="tree"
                node-key="id"
                :current-node-key="selectNodeId"
                :default-expanded-keys="idExpandedArr"
                :expand-on-click-node="false"
                :data="treeData"
                :props="defaultProps"
                :filter-node-method="filterNode"
                @node-click="handleTreeNode"
                :class="defaultClass"
            />
            <el-input :disabled="isRead"  slot="reference" readonly v-model="popoverTreeLable"></el-input>
               <el-button  v-if="!isRead" style="margin-right:20px;float:right;margin-top:10%"  @click="resetChecked">清空</el-button>
        </el-popover>
    </div>
</template>

<script>
    import { getBusinessTreeList, getCustomerBusinessTreeList, getBusinessTreeListNoCache } from '@/data-model';
    export default {
        name: 'BusinessTree',
        data () {
            return {
                filterText: '',
                idExpandedArr: [],
                treeData: [],
                selectNodeId: 0,
                popoverTreeLable: '',
                visible: false
            };
        },
        watch: {
            filterText (val) {
                this.$refs.tree.filter(val);
            }
        },
        props: {
            rootId: { // 获取节点树结构数据时的根节点id
                type: [ Number, String ]
            },
            data: { // 外部传入的树的结构数据，如果没有传，使用组件自己的接口获取数据
                type: Array
            },
            selectedNode: { // 默认选中的树节点对象
                type: Object
            },
            defaultProps: { // 默认字段名配置
                type: Object
            },
            popover: { // 是否为弹出树
                type: Boolean,
                default: false
            },
            channelFlag: { // 外部传入的渠道标识，默认是客户使用，US客户，CS客服
                type: String
            },
            appId: { // 外部传入的渠道标识，所属应用（客服系统过来用）
                type: String
            },
            isRead: {
                type: Boolean,
                default: false
            },
            defaultClass: {
                type: String,
                default: 'business-tree'
            },
            defaultExpandAll: {
                type: Boolean,
                default: true
            },
            field: {
                type: Object
            }
        },
        created () {
            this._initPage().then(val => {
                // 初始化默认展开到第二级
                if (this.treeData && this.treeData.length > 0) {
                    this.idExpandedArr = [];
                    this.idExpandedArr.push(this.treeData[0].id);
                }
            });
        },
        methods: {
            async _initPage () {
                // console.log(this.channelFlag+"===="+this.appId );
                await this._getTreeData();
                this._setSelectedNode();
            },
            async _getTreeData () {
                let businessTreeList = [];
                if (this.data) {
                    businessTreeList = this.data;
                } else {
                    if (this.channelFlag === 'CS') {
                        businessTreeList = await getCustomerBusinessTreeList(this.appId);
                    } else {
                        let isRelatedDepartments = false;
                        if (this.field) {
                            if (this.field.options && this.field.options.ext2) {
                                let ext2 = this.field.options.ext2;
                                let obj = JSON.parse(ext2);
                                if (obj.isRelatedDepartments && obj.isRelatedDepartments == true) {
                                    isRelatedDepartments = true;
                                }
                            }
                        }
                        if (isRelatedDepartments) {
                            businessTreeList = await getBusinessTreeListNoCache(this.rootId, isRelatedDepartments);
                        } else {
                            businessTreeList = await getBusinessTreeList(this.rootId, isRelatedDepartments);
                        }
                    }
                }
                this.treeData = businessTreeList;
            },
            _setSelectedNode () {
                if (this.selectedNode) {
                    this.popoverTreeLable = this.selectedNode.label;
                    this.selectNodeId = this.selectedNode.id;
                }
            },
            _refreshSelectedNode (node) {
                if (node) {
                    this.popoverTreeLable = node.title;
                    this.selectNodeId = node.value;
                }
            },
            handleTreeNode (data, node, tree) {
                if (this.field && this.field.options.ext2) {
                    let ext2 = this.field.options.ext2;
                    let ext2Obj = JSON.parse(ext2);
                    if (ext2Obj.businessTreeChooseSonNode) { // 只能选择子节点
                        if (data.children && data.children.length > 0) {
                            this.$message.error('当前字段配置只允许选择子节点，请选择子节点');
                        } else {
                            this.popoverTreeLable = data.label;
                            this.selectNodeId = data.id;
                            this.$emit('nodeClick', data, node, tree);
                            this.visible = false;
                        }
                    } else if (ext2Obj.businessTreeChooseParentNode) { // 只能选择父节点
                        if (!data.children || data.children.length === 0) {
                            this.$message.error('当前字段配置只允许选择父节点，请选择父节点');
                        } else {
                            this.popoverTreeLable = data.label;
                            this.selectNodeId = data.id;
                            this.$emit('nodeClick', data, node, tree);
                            this.visible = false;
                        }
                    } else {
                        this.popoverTreeLable = data.label;
                        this.selectNodeId = data.id;
                        this.$emit('nodeClick', data, node, tree);
                        this.visible = false;
                    }
                } else {
                    this.popoverTreeLable = data.label;
                    this.selectNodeId = data.id;
                    this.$emit('nodeClick', data, node, tree);
                    this.visible = false;
                }
            },
            setTreeStatus () {
                // this.$refs.tree.setCurrentNode(2);
                this.$nextTick().then(() => {
                    if (this.$refs.tree) {
                        this.$refs.tree.setCurrentKey(this.selectNodeId);
                    }
                });
            },
            treeShow () {
                // console.log('treeShow');
                this.setTreeStatus();
                this.$emit('treeShow');
            },
            resetChecked () {
                this.popoverTreeLable = '';
                this.selectedContent = this.popoverTreeLable;
                let node = {selectedIds: '', selectedNames: ''};
                this.$refs.tree.setCheckedKeys([]);
                this.$emit('nodeClick', node);
                this.visible = false;
            },
            filterNode (value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/BusinessTree/BusinessTree.vue